<template>
  <div class="pa-4">
    <div v-if="report">
      <div>
        <div>
          <div>
            <table style="width:100%;text-align:center;">
              <tr>
                <td style="width:50%;">&quot;КРЕДИТ-АХБОРОТ ТАХЛИЛИЙ МАРКАЗИ&quot; КРЕДИТ БЮРОСИ</td>
                <td style="width:50%;">CREDIT BUREAU &quot;CREDIT INFORMATION-ANALYTICAL CENTRE&quot;</td>
              </tr>
              <tr>
                <td colspan="2" style="border-top:3px solid #17365d;font-size:12px;border-bottom:3px solid #17365d;">
                  Pochta manzili: 100027, Тоshkent sh., Qoratosh к., 1 uy. Banklararo telekommunikasion tarmoqdagi
                  elektron manzili (lotus notes): &quot;katm1/Uzb@Banks&quot;; telefon:(99871) 238 69 71; 238 69 31
                </td>
              </tr>
            </table>
            <p class="mt-5">
              <b>Внимание:</b> {{report.sysinfo.declaration}}</p>
          </div>
        </div>
      </div>
      <v-row>
        <v-col md="6" cols="12">
          <h4 class="mb-4">Идентификация субъекта кредитной информации</h4>
          <v-simple-table class="small-table pa-4">
            <thead>
            <tr>
              <th>№</th>
              <th>Тип информации</th>
              <th>Информация</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                1
              </td>
              <td style="text-align:left">
                Наименование заёмщика
              </td>
              <td style="text-align:left">
                <span>{{report.client.name}}</span>
              </td>
            </tr>
            <tr>
              <td>
                2
              </td>
              <td style="text-align:left">
                <span>Дата рождения</span>
              </td>
              <td style="text-align:left">
                <span>{{report.client.birth_date}}</span>
              </td>
            </tr>
            <tr>
              <td>
                3
              </td>
              <td style="text-align:left">
                Резидентность
              </td>
              <td style="text-align:left">
                <span>Резидент</span>
              </td>
            </tr>
            <tr>
              <td>
                4
              </td>
              <td style="text-align:left">
                <span>Телефон</span>
              </td>
              <td style="text-align:left">
                <span>{{report.client.phone}}</span>
              </td>
            </tr>
            <tr>
              <td>
                5
              </td>
              <td style="text-align:left">
                <span>Адрес по прописке</span>
              </td>
              <td style="text-align:left">
                <span>{{report.client.address}}</span>
              </td>
            </tr>
            <tr>
              <td>
                6
              </td>
              <td style="text-align:left">
                ПИНФЛ
              </td>
              <td style="text-align:left">
                <!--                <span>{{report.user.pnfl}}</span>-->
              </td>
            </tr>
            <tr>
              <td>
                7
              </td>
              <td style="text-align:left">
                ИНН
              </td>
              <td style="text-align:left">
                <span>{{report.client.inn}}</span>
              </td>
            </tr>
            <tr>
              <td>
                8
              </td>
              <td style="text-align:left">
                <span>Тип документа</span>
              </td>
              <td style="text-align:left">
                <span>{{report.client.document_type === 6 ? 'Биометрический паспорт гражданина Республики Узбекистан' : ''}}</span>
              </td>
            </tr>
            <tr>
              <td>
                9
              </td>
              <td style="text-align:left">
                <span>Данные документа</span>
              </td>
              <td style="text-align:left">
                <span>{{report.client.document_serial || report.client.document_number ||  report.client.document_date}}</span>
              </td>
            </tr>
            <tr>
              <td>
                10
              </td>
              <td style="text-align:left">
                Пользователь кредитного отчёта
              </td>
              <td style="text-align:left">
                <span>YANGI ASR MEROS (оффлайн)</span>
              </td>
            </tr>
            <tr>
              <td>
                11
              </td>
              <td style="text-align:left">
                Кредитная заявка
              </td>
              <td style="text-align:left">
                <span>{{report.sysinfo.claim_id}} от {{report.sysinfo.date}}</span>
              </td>
            </tr>
            <tr>
              <td>
                12
              </td>
              <td style="text-align:left">
                № запроса пользователя
              </td>
              <td style="text-align:left">
                <span>{{report.sysinfo.demand_id}}</span>
              </td>
            </tr>
            </tbody>
          </v-simple-table>
          <h4 class="my-4">Сведения о наличии возможности получения кредитных отчетов по заёмщику</h4>
          <v-simple-table class="pa-4 small-table">
            <thead>
            <tr>
              <th>Тип кредитного отчета:</th>
              <th>Идентификация субъекта кредитной информации</th>
              <th>Информация по кредитам</th>
              <th>Статистика запросов</th>
              <th>Скоринговый балл</th>
            </tr>
            </thead>
            <tbody>
            <tr class="center_class">
              <td class="header-color">
                Наличные
              </td>
              <td>
                <span>Да</span>
              </td>
              <td>
                <span>Нет</span>
              </td>
              <td>
                <span>Да</span>
              </td>
              <td>
                <span>Да</span>
              </td>
            </tr>
            <tr class="center_class">
              <td class="header-color">
                Дата обновления
              </td>
              <td>
                <span>16.08.2020</span>
              </td>
              <td>
                <span>-</span>
              </td>
              <td>
                <span>16.08.2020</span>
              </td>
              <td>
                <span>16.08.2020</span>
              </td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col md="6" cols="12">
          <h4 class="mb-4">Информация об обращениях субъекта</h4>
          <v-simple-table class="pa-4 small-table">
            <thead>
            <tr>
              <td>
                №
              </td>
              <th>
                Тип организации
              </th>
              <th>
                Количество заявок
              </th>
              <th>
                Количество отклонений
              </th>
              <th>
                Количество договоров
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                1
              </td>
              <td>
                <span>Коммерческий банк</span>
              </td>
              <td>
                <span>{{report.subject_claims.bank_claims.granted_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.bank_claims.rejected_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.bank_claims.claims_qty}}</span>
              </td>
            </tr>
            <tr>
              <td>
                2
              </td>
              <td>
                <span>Лизинговая компания</span>
              </td>
              <td>
                <span>{{report.subject_claims.leasing_claims.granted_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.leasing_claims.rejected_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.leasing_claims.claims_qty}}</span>
              </td>
            </tr>
            <tr>
              <td>
                3
              </td>
              <td>
                <b/>
                <span>Ломбард</span>
              </td>
              <td>
                <span>{{report.subject_claims.lombard_claims.granted_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.lombard_claims.rejected_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.lombard_claims.claims_qty }}</span>
              </td>
            </tr>
            <tr>
              <td>
                4
              </td>
              <td>
                <span>Микрокредитная организация</span>
              </td>
              <td>
                <span>{{report.subject_claims.mko_claims.granted_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.mko_claims.rejected_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.mko_claims.claims_qty}}</span>
              </td>
            </tr>
            <tr>
              <td>
                5
              </td>
              <td>
                <span>Ритейл</span>
              </td>
              <td>
                <span>{{report.subject_claims.retail_claims.granted_qty}}</span>
              </td>
              <td>
                <span>{{report.subject_claims.retail_claims.rejected_qty  }}</span>
              </td>
              <td>
                <span>{{report.subject_claims.retail_claims.claims_qty }}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                Итого
              </td>
              <td>
                <span>{{subjectClaimsSum.granted_qty}}</span>
              </td>
              <td>
                <span>{{subjectClaimsSum.rejected_qty}}</span>
              </td>
              <td>
                <span>{{subjectClaimsSum.claims_qty}}</span>
              </td>
            </tr>
            </tbody>
          </v-simple-table>
          <h4 class="my-4">Информация о наличии задолженности субъекта</h4>
          <v-simple-table class="small-table pa-4">
            <tr class="center_class">
              <td>{{report.lombard_inquiry ? "Сумма: " + report.lombard_inquiry : "Задолженность отсутствует"}}
              </td>
            </tr>
          </v-simple-table>
          <h4 class="my-4">Среднемесячный платёж</h4>
          <v-simple-table class="pa-4">
            <tr class="center_class">
              <td> 0 сум.</td>
            </tr>
          </v-simple-table>
        </v-col>
      </v-row>
    </div>
    <div class="d-flex justify-center align-center" style="height: 90vh" v-if="errorMessage">
      <h1 class="error--text">{{errorMessage}}</h1>
    </div>
  </div>
</template>

<script>
    export default {
        props: ['creditId'],
        data() {
            return {
                report: null,
                errorMessage: null
            }
        },
        methods: {
            setError (e) {
                if (e.response && e.response.data && e.response.data.message) {
                    this.errorMessage = e.response.data.message
                }
            },
            async getReportByCreditId() {
                try {
                    this.errorMessage = null
                    const {data: {data}} = await this.$http.get(`/admin/credit/katm/info/${this.creditId}`)
                    this.report = JSON.parse(data).report
                } catch (e) {
                    this.$setResponseError({error: e})
                    this.setError(e)
                }
            },
            async getReportByUser({pnfl, passport_series, passport_number, region_katm_code, district_katm_code, user_phone}) {
                try {
                    let formData = {
                        pnfl,
                        passport_series,
                        passport_number,
                        user_phone,
                        district_katm_code,
                        region_katm_code
                    }
                    const {data: {data}} = await this.$http.post('admin/calculate/katm', formData)
                    this.report = JSON.parse(data).report
                } catch (e) {
                    this.$setResponseError({error: e})
                    this.setError(e)
                }

            }
        },
        computed: {
            isReportByCreditId() {
                return !!this.creditId
            },
            subjectClaimsSum() {
                let subjectClaims = {
                    claims_qty: 0,
                    rejected_qty: 0,
                    granted_qty: 0
                }
                if (!this.report || !this.report.subject_claims) return subjectClaims
                try {
                    const {retail_claims, mko_claims, lombard_claims, leasing_claims, bank_claims} = this.report.subject_claims
                    subjectClaims.claims_qty = retail_claims.claims_qty + mko_claims.claims_qty + lombard_claims.claims_qty + leasing_claims.claims_qty + bank_claims.claims_qty
                    subjectClaims.rejected_qty = retail_claims.rejected_qty + mko_claims.rejected_qty + lombard_claims.rejected_qty + leasing_claims.rejected_qty + bank_claims.rejected_qty
                    subjectClaims.granted_qty = retail_claims.granted_qty + mko_claims.granted_qty + lombard_claims.granted_qty + leasing_claims.granted_qty + bank_claims.granted_qty
                } catch (e) {
                    console.error(e)
                }
                return subjectClaims
            }

        },
        async mounted() {
            const {pnfl, passport_series, passport_number, region_katm_code, district_katm_code, user_phone} = this.$route.query
            this.$showLoading()
            if (this.isReportByCreditId) {
                await this.getReportByCreditId()
            } else if (pnfl && passport_number && passport_series && region_katm_code && district_katm_code && user_phone) {
                await this.getReportByUser({pnfl, passport_series, passport_number, region_katm_code, district_katm_code, user_phone})
            }
            this.$clearLoading()
        }
    }
</script>
